export const PhonePreview = () => {
  return (
    <div>
      <div className="hidden lg:block px-6">
        <div
          className="relative flex justify-center items-center"
          style={{ width: "clamp(280px, 40vw, 480px)" }}
        >

          {/* PHONE */}
          <img
            src="/images/Webp/Mobile2wt.webp"
            className="relative z-10"
            style={{ width: "clamp(180px, 28vw, 360px)" }}
          />

          {/* DEAL CARDS */}
          {[
            {
              top: "clamp(40px, 6vw, 50px)",
              left: "clamp(-10px, -2vw, -20px)",
              animation: "animate-floatSlowReverse",
              icon: "/images/RedwthiteHeart.svg",
              title: "Premium Car Wash",
              highlight: "40% OFF",
              sub: "Limited-time offer",
            },
            {
              top: "clamp(140px, 16vw, 180px)",
              right: "clamp(-10px, -2vw, -20px)",
              animation: "animate-floatSlow",
              icon: "/images/WhiteRedHeart.svg",
              title: "Artisan Bakery",
              highlight: "40% BOGO Free Freshly baked",
              sub: "Today only",
            },
            {
              bottom: "clamp(20px, 3vw, 30px)",
              left: "clamp(-10px, -2vw, -20px)",
              animation: "animate-floatSlowDelay",
              icon: "/images/RedwthiteHeart.svg",
              title: "Fitness Studio",
              highlight: "First Month Free",
              sub: "Join now, cancel anytime",
            },
          ].map(({ animation, icon, title, highlight, sub, ...position }, i) => (
            <div
              key={i}
              className={`absolute flex items-center transbox backdrop-blur-xl border-solid border-white ${animation} z-20`}
              style={{
                ...position,
                gap: "clamp(8px, 1vw, 16px)",
                padding: "clamp(10px, 1.2vw, 16px) clamp(12px, 1.5vw, 20px)",
                borderRadius: "clamp(16px, 2vw, 26px)",
                borderWidth: "clamp(2px, 0.3vw, 4px)",
                boxShadow: "0px 40px 80px rgba(0,0,0,0.18)",
              }}
            >
              <img
                src={icon}
                alt=""
                aria-hidden="true"
                className="object-cover border-2 border-white flex-shrink-0"
                style={{
                  width: "clamp(36px, 4vw, 64px)",
                  height: "clamp(36px, 4vw, 64px)",
                  borderRadius: "clamp(8px, 1vw, 15px)",
                }}
              />
              <div>
                <div className="font-semibold text-black" style={{ fontSize: "clamp(10px, 1.1vw, 18px)" }}>
                  {title}
                </div>
                <div className="font-semibold text-black" style={{ fontSize: "clamp(8px, 1.1vw, 14px)" }}>
                  {highlight}
                </div>
                <div className="font-normal text-black" style={{ fontSize: "clamp(8px, 0.85vw, 14px)", maxWidth: "clamp(80px, 12vw, 220px)" }}>
                  {sub}
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>

      <div className="block lg:hidden  ">
        <div className="relative flex justify-center items-center w-full max-w-[420px] mx-auto">

          {/* PHONE */}
          <img
            src="/images/Webp/Mobile2wt.webp"
            className="w-[280px] sm:w-[320px] relative z-10"
          />

          {/* CARDS */}
          {[
            {
              top: "clamp(10px, 5vw, 30px)",
              left: "clamp(-80px, -12vw, -110px)",
              animation: "animate-floatSlow",
              icon: "/images/WhiteRedHeart.svg",
              title: "Premium Car Wash",
              highlight: "40% OFF",
              sub: "Limited-time offer",
            },
            {
              top: "clamp(140px, 16vw, 200px)",
              right: "clamp(-80px, -12vw, -110px)",
              animation: "animate-floatSlowReverse",
              icon: "/images/RedwthiteHeart.svg",
              title: "Artisan Bakery",
              highlight: "BOGO Free",
              sub: "Freshly baked, today only",
            },
            {
              bottom: "clamp(10px, 5vw, 30px)",
              left: "clamp(-80px, -12vw, -110px)",
              animation: "animate-floatSlowDelay",
              icon: "/images/RedwthiteHeart.svg",
              title: "Fitness Studio",
              highlight: "First Month Free",
              sub: "Join now, cancel anytime",
            },
          ].map(({ animation, icon, title, highlight, sub, ...position }, i) => (
            <div
              key={i}
              className={`absolute flex items-center transbox backdrop-blur-xl border-solid border-white ${animation} z-20`}
              style={{
                ...position,
                gap: "clamp(10px, 2vw, 16px)",
                padding: "clamp(10px, 2vw, 16px) clamp(12px, 2.5vw, 20px)",
                borderRadius: "clamp(16px, 3vw, 24px)",
                borderWidth: "clamp(2px, 0.5vw, 4px)",
                boxShadow: "0px 20px 40px rgba(0,0,0,0.15)",
              }}
            >
              <img
                src={icon}
                alt=""
                aria-hidden="true"
                className="flex-shrink-0 object-cover"
                style={{
                  width: "clamp(44px, 8vw, 64px)",
                  height: "clamp(44px, 8vw, 64px)",
                  borderRadius: "clamp(10px, 2vw, 14px)",
                }}
              />
              <div>
                <div className="text-black font-semibold text-start" style={{ fontSize: "clamp(12px, 2.2vw, 16px)" }}>
                  {title}
                </div>
                <div className="font-semibold text-black text-start" style={{ fontSize: "clamp(11px, 2.2vw, 14px)" }}>
                  {highlight}
                </div>
                <div className="text-black font-normal text-start" style={{ fontSize: "clamp(10px, 1.8vw, 13px)" }}>
                  {sub}
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
    </div>

  );
};